/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetApiStatementsCsvExportColumns200,
  GetApiStatementsJobStatusJobId200,
  GetApiStatementsZipStatusJobId200,
  PatchApiStatementsStatementIdApiBodies,
  PostApiStatementsJob201,
  PostApiStatementsJobAll201,
  PostApiStatementsJobAllApiBodies,
  PostApiStatementsJobApiBodies,
  PostApiStatementsSummaryCsvApiBodies,
  PostApiStatementsZipZip200,
  PostApiStatementsZipZipApiBodies
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const postApiStatementsJob = (
    postApiStatementsJobApiBodies: PostApiStatementsJobApiBodies,
 ) => {
      
      
      return customInstance<PostApiStatementsJob201>(
      {url: `/api/statements/job`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiStatementsJobApiBodies
    },
      );
    }
  


export const getPostApiStatementsJobMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJob>>, TError,{data: PostApiStatementsJobApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJob>>, TError,{data: PostApiStatementsJobApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStatementsJob>>, {data: PostApiStatementsJobApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiStatementsJob(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStatementsJobMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStatementsJob>>>
    export type PostApiStatementsJobMutationBody = PostApiStatementsJobApiBodies
    export type PostApiStatementsJobMutationError = ErrorType<unknown>

    export const usePostApiStatementsJob = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJob>>, TError,{data: PostApiStatementsJobApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiStatementsJob>>,
        TError,
        {data: PostApiStatementsJobApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiStatementsJobMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const patchApiStatementsStatementId = (
    statementId: string,
    patchApiStatementsStatementIdApiBodies: PatchApiStatementsStatementIdApiBodies,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/statements/${statementId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchApiStatementsStatementIdApiBodies
    },
      );
    }
  


export const getPatchApiStatementsStatementIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiStatementsStatementId>>, TError,{statementId: string;data: PatchApiStatementsStatementIdApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiStatementsStatementId>>, TError,{statementId: string;data: PatchApiStatementsStatementIdApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiStatementsStatementId>>, {statementId: string;data: PatchApiStatementsStatementIdApiBodies}> = (props) => {
          const {statementId,data} = props ?? {};

          return  patchApiStatementsStatementId(statementId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiStatementsStatementIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiStatementsStatementId>>>
    export type PatchApiStatementsStatementIdMutationBody = PatchApiStatementsStatementIdApiBodies
    export type PatchApiStatementsStatementIdMutationError = ErrorType<unknown>

    export const usePatchApiStatementsStatementId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiStatementsStatementId>>, TError,{statementId: string;data: PatchApiStatementsStatementIdApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiStatementsStatementId>>,
        TError,
        {statementId: string;data: PatchApiStatementsStatementIdApiBodies},
        TContext
      > => {

      const mutationOptions = getPatchApiStatementsStatementIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApiStatementsStatementIdFull = (
    statementId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/statements/${statementId}/full`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiStatementsStatementIdFullMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>, TError,{statementId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>, TError,{statementId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>, {statementId: string}> = (props) => {
          const {statementId} = props ?? {};

          return  deleteApiStatementsStatementIdFull(statementId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiStatementsStatementIdFullMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>>
    
    export type DeleteApiStatementsStatementIdFullMutationError = ErrorType<unknown>

    export const useDeleteApiStatementsStatementIdFull = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>, TError,{statementId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiStatementsStatementIdFull>>,
        TError,
        {statementId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiStatementsStatementIdFullMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApiStatementsStatementIdRows = (
    statementId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/statements/${statementId}/rows`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiStatementsStatementIdRowsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>, TError,{statementId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>, TError,{statementId: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>, {statementId: string}> = (props) => {
          const {statementId} = props ?? {};

          return  deleteApiStatementsStatementIdRows(statementId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiStatementsStatementIdRowsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>>
    
    export type DeleteApiStatementsStatementIdRowsMutationError = ErrorType<unknown>

    export const useDeleteApiStatementsStatementIdRows = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>, TError,{statementId: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiStatementsStatementIdRows>>,
        TError,
        {statementId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiStatementsStatementIdRowsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiStatementsJobAll = (
    postApiStatementsJobAllApiBodies: PostApiStatementsJobAllApiBodies,
 ) => {
      
      
      return customInstance<PostApiStatementsJobAll201>(
      {url: `/api/statements/job-all`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiStatementsJobAllApiBodies
    },
      );
    }
  


export const getPostApiStatementsJobAllMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJobAll>>, TError,{data: PostApiStatementsJobAllApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJobAll>>, TError,{data: PostApiStatementsJobAllApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStatementsJobAll>>, {data: PostApiStatementsJobAllApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiStatementsJobAll(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStatementsJobAllMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStatementsJobAll>>>
    export type PostApiStatementsJobAllMutationBody = PostApiStatementsJobAllApiBodies
    export type PostApiStatementsJobAllMutationError = ErrorType<unknown>

    export const usePostApiStatementsJobAll = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsJobAll>>, TError,{data: PostApiStatementsJobAllApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiStatementsJobAll>>,
        TError,
        {data: PostApiStatementsJobAllApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiStatementsJobAllMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiStatementsJobStatusJobId = (
    jobId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiStatementsJobStatusJobId200>(
      {url: `/api/statements/jobStatus/${jobId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsJobStatusJobIdQueryKey = (jobId: string,) => {
    return [`/api/statements/jobStatus/${jobId}`] as const;
    }

    
export const getGetApiStatementsJobStatusJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsJobStatusJobIdQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>> = ({ signal }) => getApiStatementsJobStatusJobId(jobId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsJobStatusJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>>
export type GetApiStatementsJobStatusJobIdQueryError = ErrorType<unknown>

export const useGetApiStatementsJobStatusJobId = <TData = Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsJobStatusJobId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsJobStatusJobIdQueryOptions(jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsStatementIdStatementPdf = (
    statementId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/statements/${statementId}/statement.pdf`, method: 'GET',
        responseType: 'blob', signal
    },
      );
    }
  

export const getGetApiStatementsStatementIdStatementPdfQueryKey = (statementId: string,) => {
    return [`/api/statements/${statementId}/statement.pdf`] as const;
    }

    
export const getGetApiStatementsStatementIdStatementPdfQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>, TError = ErrorType<unknown>>(statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsStatementIdStatementPdfQueryKey(statementId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>> = ({ signal }) => getApiStatementsStatementIdStatementPdf(statementId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(statementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsStatementIdStatementPdfQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>>
export type GetApiStatementsStatementIdStatementPdfQueryError = ErrorType<unknown>

export const useGetApiStatementsStatementIdStatementPdf = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>, TError = ErrorType<unknown>>(
 statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementPdf>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsStatementIdStatementPdfQueryOptions(statementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsCsvExportColumns = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiStatementsCsvExportColumns200>(
      {url: `/api/statements/csv-export-columns`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsCsvExportColumnsQueryKey = () => {
    return [`/api/statements/csv-export-columns`] as const;
    }

    
export const getGetApiStatementsCsvExportColumnsQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsCsvExportColumnsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>> = ({ signal }) => getApiStatementsCsvExportColumns(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsCsvExportColumnsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>>
export type GetApiStatementsCsvExportColumnsQueryError = ErrorType<unknown>

export const useGetApiStatementsCsvExportColumns = <TData = Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsCsvExportColumns>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsCsvExportColumnsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsStatementIdStatementCsv = (
    statementId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/statements/${statementId}/statement.csv`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsStatementIdStatementCsvQueryKey = (statementId: string,) => {
    return [`/api/statements/${statementId}/statement.csv`] as const;
    }

    
export const getGetApiStatementsStatementIdStatementCsvQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>, TError = ErrorType<unknown>>(statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsStatementIdStatementCsvQueryKey(statementId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>> = ({ signal }) => getApiStatementsStatementIdStatementCsv(statementId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(statementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsStatementIdStatementCsvQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>>
export type GetApiStatementsStatementIdStatementCsvQueryError = ErrorType<unknown>

export const useGetApiStatementsStatementIdStatementCsv = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>, TError = ErrorType<unknown>>(
 statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdStatementCsv>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsStatementIdStatementCsvQueryOptions(statementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsStatementIdBasicStatementCsv = (
    statementId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/statements/${statementId}/basic-statement.csv`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsStatementIdBasicStatementCsvQueryKey = (statementId: string,) => {
    return [`/api/statements/${statementId}/basic-statement.csv`] as const;
    }

    
export const getGetApiStatementsStatementIdBasicStatementCsvQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>, TError = ErrorType<unknown>>(statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsStatementIdBasicStatementCsvQueryKey(statementId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>> = ({ signal }) => getApiStatementsStatementIdBasicStatementCsv(statementId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(statementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsStatementIdBasicStatementCsvQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>>
export type GetApiStatementsStatementIdBasicStatementCsvQueryError = ErrorType<unknown>

export const useGetApiStatementsStatementIdBasicStatementCsv = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>, TError = ErrorType<unknown>>(
 statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdBasicStatementCsv>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsStatementIdBasicStatementCsvQueryOptions(statementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsStatementIdArtworkChannelStatementCsv = (
    statementId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/statements/${statementId}/artwork-channel-statement.csv`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsStatementIdArtworkChannelStatementCsvQueryKey = (statementId: string,) => {
    return [`/api/statements/${statementId}/artwork-channel-statement.csv`] as const;
    }

    
export const getGetApiStatementsStatementIdArtworkChannelStatementCsvQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>, TError = ErrorType<unknown>>(statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsStatementIdArtworkChannelStatementCsvQueryKey(statementId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>> = ({ signal }) => getApiStatementsStatementIdArtworkChannelStatementCsv(statementId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(statementId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsStatementIdArtworkChannelStatementCsvQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>>
export type GetApiStatementsStatementIdArtworkChannelStatementCsvQueryError = ErrorType<unknown>

export const useGetApiStatementsStatementIdArtworkChannelStatementCsv = <TData = Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>, TError = ErrorType<unknown>>(
 statementId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsStatementIdArtworkChannelStatementCsv>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsStatementIdArtworkChannelStatementCsvQueryOptions(statementId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getApiStatementsMonthYearSummaryCsv = (
    month: number,
    year: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<unknown>(
      {url: `/api/statements/${month}/${year}/summary.csv`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsMonthYearSummaryCsvQueryKey = (month: number,
    year: number,) => {
    return [`/api/statements/${month}/${year}/summary.csv`] as const;
    }

    
export const getGetApiStatementsMonthYearSummaryCsvQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>, TError = ErrorType<unknown>>(month: number,
    year: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsMonthYearSummaryCsvQueryKey(month,year);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>> = ({ signal }) => getApiStatementsMonthYearSummaryCsv(month,year, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(month && year), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsMonthYearSummaryCsvQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>>
export type GetApiStatementsMonthYearSummaryCsvQueryError = ErrorType<unknown>

export const useGetApiStatementsMonthYearSummaryCsv = <TData = Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>, TError = ErrorType<unknown>>(
 month: number,
    year: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsMonthYearSummaryCsv>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsMonthYearSummaryCsvQueryOptions(month,year,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiStatementsSummaryCsv = (
    postApiStatementsSummaryCsvApiBodies: PostApiStatementsSummaryCsvApiBodies,
 ) => {
      
      
      return customInstance<unknown>(
      {url: `/api/statements/summary.csv`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiStatementsSummaryCsvApiBodies
    },
      );
    }
  


export const getPostApiStatementsSummaryCsvMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>, TError,{data: PostApiStatementsSummaryCsvApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>, TError,{data: PostApiStatementsSummaryCsvApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>, {data: PostApiStatementsSummaryCsvApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiStatementsSummaryCsv(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStatementsSummaryCsvMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>>
    export type PostApiStatementsSummaryCsvMutationBody = PostApiStatementsSummaryCsvApiBodies
    export type PostApiStatementsSummaryCsvMutationError = ErrorType<unknown>

    export const usePostApiStatementsSummaryCsv = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>, TError,{data: PostApiStatementsSummaryCsvApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiStatementsSummaryCsv>>,
        TError,
        {data: PostApiStatementsSummaryCsvApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiStatementsSummaryCsvMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const postApiStatementsZipZip = (
    postApiStatementsZipZipApiBodies: PostApiStatementsZipZipApiBodies,
 ) => {
      
      
      return customInstance<PostApiStatementsZipZip200>(
      {url: `/api/statements/zip.zip`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApiStatementsZipZipApiBodies
    },
      );
    }
  


export const getPostApiStatementsZipZipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsZipZip>>, TError,{data: PostApiStatementsZipZipApiBodies}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsZipZip>>, TError,{data: PostApiStatementsZipZipApiBodies}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiStatementsZipZip>>, {data: PostApiStatementsZipZipApiBodies}> = (props) => {
          const {data} = props ?? {};

          return  postApiStatementsZipZip(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiStatementsZipZipMutationResult = NonNullable<Awaited<ReturnType<typeof postApiStatementsZipZip>>>
    export type PostApiStatementsZipZipMutationBody = PostApiStatementsZipZipApiBodies
    export type PostApiStatementsZipZipMutationError = ErrorType<unknown>

    export const usePostApiStatementsZipZip = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiStatementsZipZip>>, TError,{data: PostApiStatementsZipZipApiBodies}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiStatementsZipZip>>,
        TError,
        {data: PostApiStatementsZipZipApiBodies},
        TContext
      > => {

      const mutationOptions = getPostApiStatementsZipZipMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiStatementsZipStatusJobId = (
    jobId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiStatementsZipStatusJobId200>(
      {url: `/api/statements/zipStatus/${jobId}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiStatementsZipStatusJobIdQueryKey = (jobId: string,) => {
    return [`/api/statements/zipStatus/${jobId}`] as const;
    }

    
export const getGetApiStatementsZipStatusJobIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>, TError = ErrorType<unknown>>(jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiStatementsZipStatusJobIdQueryKey(jobId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>> = ({ signal }) => getApiStatementsZipStatusJobId(jobId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(jobId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiStatementsZipStatusJobIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>>
export type GetApiStatementsZipStatusJobIdQueryError = ErrorType<unknown>

export const useGetApiStatementsZipStatusJobId = <TData = Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>, TError = ErrorType<unknown>>(
 jobId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiStatementsZipStatusJobId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiStatementsZipStatusJobIdQueryOptions(jobId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



